import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import global_ from './Global'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// import 'swiper/swiper-bundle.css';
import vueSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import VueWechatTitle from 'vue-wechat-title'
Vue.use(VueWechatTitle)
Vue.use(vueSwiper)
Vue.config.productionTip = false
Vue.prototype.$global = global_
Vue.use(ElementUI);
// 定义全局的微信分享功能？
new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')
